const COLORS = [
  '#00cfff', '#006f4e', '#383f51', '#298ed2', '#ddbbb2',
  '#f15f76', '#de376d', '#4169E1', '#808080', '#A3876A',
  '#FFA500', '#8A2BE2'
];

const labelColorMap = {};

export function getColorsForLabels(labels) {
  const colors = [];
  let i = 0;
  for (const label of labels) {
    if (!labelColorMap[label]) {
      labelColorMap[label] = COLORS[i % COLORS.length];
      i++;
    }
    colors.push(labelColorMap[label]);
  }
  return colors;
}
